import Vue from "vue";
import Router from "vue-router";
import Home from "./views/HomeView.vue";
import Especies from "./components/Especies.vue";
import Lista from "./components/Lista.vue";
import Textura from "./components/Textura.vue";
import Parenquima from "./components/Parenquima.vue";
import Poros from "./components/Poros.vue";
import Radios from "./components/Radios.vue";
import Inclusiones from "./components/Inclusiones.vue";
//Fase 2
import Rol from "./components/Rol.vue";
import Administracion from "./components/Administracion.vue";
import User from "./components/User.vue";
import Recursos from "./components/Recursos.vue";
import Contacto from "./components/Contacto.vue";
import Glosario from "./components/Glosario.vue";
import Creditos from "./components/Creditos.vue";
Vue.use(Router);

const router =  new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
        },
        {
            path: "/especie",
            name: "especie",
            component: Especies,
        },
        {
            path: "/lista",
            name: "lista",
            component: Lista,
        },
        {
            path: "/textura",
            name: "textura",
            component: Textura,
        },
        {
            path: "/parenquima",
            name: "parenquima",
            component: Parenquima,
        },
        {
            path: "/poros",
            name: "poros",
            component: Poros,
        },
        {
            path: "/radios",
            name: "radios",
            component: Radios,
        },
        {
            path: "/inclusiones",
            name: "inclusiones",
            component: Inclusiones,
        },
        {
            path: "/rol",
            name: "rol",
            component: Rol,
        },
        {
            path: "/administracion",
            name: "administracion",
            component: Administracion,
        },
        {
            path: "/user",
            name: "user",
            component: User,
        },
        {
            path: "/contacto",
            name: "contacto",
            component: Contacto,
        },
        {
            path: "/recursos",
            name: "recursos",
            component: Recursos,
        },
        {
            path: "/glosario",
            name: "glosario",
            component: Glosario,            
        },
        {
            path: "/creditos",
            name: "creditos",
            component: Creditos,            
        }
    ],
});

export default router;